// extracted by mini-css-extract-plugin
module.exports = {"section":"mobility-drag-drop_section__3rSzO"};